<template>
    <section class="profit-propositions">
        <div class="wrapper">
            <h2 class="profit-propositions__title h2">Выгодные предложения</h2>
            <Tabs :tabs="profitPropositionsModel.tabsData">
                <template
                    v-for="{slotName} in profitPropositionsModel.tabsData"
                    #[slotName]
                >
                    <OfferSlider
                        :key="slotName"
                        :slides-data="modifySlides(profitPropositionsModel[slotName])"
                    />
                </template>
            </Tabs>
        </div>
    </section>
</template>

<script>
import {defineComponent} from 'vue';

import * as ProfitPropositionsModel from '@/core/models/pages/home-page/ProfitPropositionsModel';
import {useSlidesModify} from '@/core/composables/useSlidesModify';

export default defineComponent({
    name: 'ProfitPropositions',
    components: {
        OfferSlider: () => import('@/components/Sliders/OfferSlider/OfferSlider.vue'),
        Tabs: () => import('@/components/UI-components/Tabs/UITabs.vue'),
    },
    setup() {
        const {modifySlides} = useSlidesModify();

        return {
            profitPropositionsModel: ProfitPropositionsModel,
            modifySlides,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/index/profit-propositions';
</style>
